module Meevo.Plugins.Register {
    "use strict";

    export class RefundTipsSection extends Meevo.Plugins.Register.RegisterSectionBase {
        tipLines: any;
        addedTipLines: any = {};
        removedTipLines: any = {};
        previousEmployee: any;
        employee: any;
        scannedTransactionId: string = "";
        refundSubTotal: number;

        get $translate() { return this.registerContext.$translate; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get securityService() { return this.registerContext.securityService; }
        get tippyService() { return this.registerContext.tippyService; }

        constructor(
            registerContext: Meevo.Plugins.Register.RegisterContext,
            protected numberOfDaysTipCanBeRefunded: number
        ) {
            super(RegisterSectionTypeEnum.Tips, registerContext, "refundTips", Register.RegisterSectionCatTypeEnum.Sale);
        }

        isRefundChanged(tipLine) {
            if (tipLine.isRefund) {
                const refundTipLines: Model.TipLine[] = _(this.tipLines.loadedPages).flatten().filter(line => line.isRefund);

                if (this.registerContext.isMismatch(this.tippyService.getExternalRefundTransactionId(this.registerContext.sale), tipLine.externalTipTransactionId) ||
                    this.hasExternalTipTransactionIdMismatch(refundTipLines)
                ) {
                    this.registerContext.displayRefundMismatchMessage(true, false);
                    tipLine.isRefund = false;
                    return;
                }
                
                if (this.registerContext.isMismatch(this.registerContext.getAuthorizationPaymentRequestId(this.registerContext.sale), tipLine.authorizationPaymentRequestId) ||
                    this.hasAuthorizationPaymentRequestIdMismatch(refundTipLines)
                ) {
                    this.registerContext.displayRefundMismatchMessage(false, true);
                    tipLine.isRefund = false;
                    return;
                }

                if (this.removedTipLines.hasOwnProperty(tipLine.tempId)) {
                    delete this.removedTipLines[tipLine.tempId];
                } else {
                    this.addedTipLines[tipLine.tempId] = tipLine;
                }
				this.refundSubTotal = this.registerContext.normalizeDecimalPlaces(this.refundSubTotal + tipLine.amount);
            } else {
                if (this.addedTipLines.hasOwnProperty(tipLine.tempId)) {
                    delete this.addedTipLines[tipLine.tempId];
                } else {
                    this.removedTipLines[tipLine.tempId] = tipLine;
                }
	            this.refundSubTotal = this.registerContext.normalizeDecimalPlaces(this.refundSubTotal - tipLine.amount);
            }
        }

        canApplyRefund(): boolean {
            return (this.getRefundSubTotal() != this.refundSubTotal);
        }

        applyRefundItems() {
            for (let i = this.registerContext.sale.tipLines.length - 1; i >= 0; i--) {
                const tipLine = this.registerContext.sale.tipLines[i];

                if (this.removedTipLines.hasOwnProperty(tipLine.tempId || this.registerContext.getTempId(tipLine))) {
                    this.registerContext.sale.tipConvenienceFeeRefund = this.registerContext.roundingService.subtractNormalizedNumbers(this.registerContext.sale.tipConvenienceFeeRefund, (tipLine.convenienceFee || 0));
                    this.registerContext.sale.tipLines.splice(i, 1);
                }
            }

            for (let addedTipLineId in this.addedTipLines) {
                if (this.addedTipLines.hasOwnProperty(addedTipLineId)) {
                    let addedTipLine = this.addedTipLines[addedTipLineId];
                    this.registerContext.addRefundTipLine(addedTipLine);

                    if (this.registerContext.sale.saleLines.length > 0) {
                        this.registerContext.sale.saleLines = _(this.registerContext.sale.saleLines).reject(x => x.saleType === Model.SalesTypeEnum.AssociatedClient && x.isRefund);
                    }

                    if (addedTipLine.clientIds && addedTipLine.clientIds.length > 0) {
                        let clientId = addedTipLine.clientIds[0];

                        this.dataService.getItem("client", clientId).then((client) => {
                            let saleLine = this.registerContext.addAssociatedClientSaleLine(client);

                            saleLine.isRefund = true;
                            saleLine.refundLocationId = addedTipLine.locationId;
                            saleLine.refundSaleDate = addedTipLine.saleDate;
                            saleLine.refundSaleId = addedTipLine.saleId;
                            saleLine.refundSaleLineId = addedTipLine.saleLineId;
                        });
                    }
                }
            }

            this.addedTipLines = {};
            this.removedTipLines = {};
            this.registerContext.tippyService.partialRefundTransaction(this.registerContext);
            this.registerContext.updateTip();
        }

        employeeChanged() {
            if ((this.employee || {}).id != (this.previousEmployee || {}).id) {
                this.loadRefundTips();
            }
            this.previousEmployee = this.employee;
        }

        getRefundTotal() {
            let refundTotal = 0;

            _(this.registerContext.sale.tipLines).where({ isRefund: true }).forEach(tipLine => {
                refundTotal += tipLine.amount;
            });

            return this.registerContext.normalizeDecimalPlaces(refundTotal);
        }

        getRefundSubTotal() {
            return this.getRefundTotal() * -1;
        }        

        reset() {
            this.addedTipLines = {};
            this.removedTipLines = {};
            this.loadRefundTips();
            this.scannedTransactionId = "";

            this.refundSubTotal = this.getRefundSubTotal();
        }

        private loadRefundTips() {
            let clientIds = _(this.registerContext.sale.saleLines).chain().where({ clientType: Model.ClientTypeEnum.Client }).pluck("clientId").unique().value();
            if (this.registerContext.selectedClientType == Model.ClientTypeEnum.Client &&
                clientIds.indexOf(this.registerContext.selectedClient.id) == -1) {
                clientIds.push(this.registerContext.selectedClient.id);
            }

            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REFUNDTIP)
                .then(result => {
                    if (result !== Model.SecurityAccessEnum.Grant) {
                        return;
                    }

                    this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_OVERRIDETIPREFUNDPOLICY)
                        .then(result => {
                            let numberOfDaysTipCanBeRefunded = result == Model.SecurityAccessEnum.Grant ? 10000 : this.numberOfDaysTipCanBeRefunded;
                            let request = {
                                pageNumber: 0,
                                itemsPerPage: 20,
                                sortDirection: Model.SortDirection.Ascending,
                                criteria: {
                                    numberOfDaysTipCanBeRefunded: numberOfDaysTipCanBeRefunded,
                                    clientIds: clientIds,
                                    employeeId: this.employee ? this.employee.id : undefined,
                                    includeAuthorizationPaymentRequest: true,
                                }
                            };
                            this.tipLines = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "saletip", this.onPageLoad, this);
                            this.tipLines.initSearch(request);
                        });
                });
        }

        onPageLoad(pageNumber, items, context) {
            const saleTipLines = context.registerContext.sale.tipLines;

            items.forEach(item => {
                item.tempId = context.registerContext.getTempId(item);
                const isSaleTipLineRefund = saleTipLines.some((tip: Model.TipLine) => {
                    return context.registerContext.getTempId(tip) == item.tempId && tip.isRefund;
                });

                if (isSaleTipLineRefund || context.addedTipLines.hasOwnProperty(item.tempId)) {
                    item.isRefund = true;
                }
            });
        }

        refundTransaction() {
            this.registerContext.getSaleLinesToRefundFromTransactionId(this.scannedTransactionId).then(() => { this.scannedTransactionId = ""; });
        }

        getEmployeeDisplayName(tipLine) {
            if (!tipLine) {
                return "";
            }

            return tipLine.employeeId
                ? tipLine.employeeDisplayName
                : this.registerContext.HouseEmployee.displayName;
        }
    }

}